import './hierarchy-toolbar.scss';

const HierarchyToolbarTop = (props: any) => {
  return  (
    <div className="hierarchy-toolbar toolbar-top">
      <div className="hierarchy-toolbar-box">
        <div className='default-buttons'>
          {
            !props.isEditing ?
            <>
              {/* TEMP DISABLED: edge case with semantic dive out when there already exists a parent topic. */}
              {/* {
                props.hasParentTopic ?
                <button onClick={props.addBroadTopic}>+ Broad Topic</button> :
                <></>
              } */}
              <button onClick={props.toggleEditing}>Edit Topic Name</button>
            </> :
            <button onClick={props.toggleEditing}>Done Editing</button>
          }
        </div>
      </div>
    </div>
  )
}

export default HierarchyToolbarTop;